//============================
//# rlgenpart_person
//============================

export default interface PartPersonRelation {
  partner: number;
  person: number;
  placeType: number;
  primaryPart: boolean;
}

export const PartPersonRelationDefaultProps: PartPersonRelation = {
  partner: 0,
  person: 0,
  placeType: 1,
  primaryPart: true,
}
